"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsToken__factory = void 0;
const ethers_1 = require("ethers");
class NounsToken__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_name, _symbol, _noundersDAO, _minter, raffleEligible, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.deploy(_name, _symbol, _noundersDAO, _minter, raffleEligible, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    getDeployTransaction(_name, _symbol, _noundersDAO, _minter, raffleEligible, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.getDeployTransaction(_name, _symbol, _noundersDAO, _minter, raffleEligible, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsToken__factory = NounsToken__factory;
const _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                internalType: "address",
                name: "_noundersDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "raffleEligible",
                type: "address[]",
            },
            {
                internalType: "contract INounsDescriptor",
                name: "_descriptor",
                type: "address",
            },
            {
                internalType: "contract INounsSeeder",
                name: "_seeder",
                type: "address",
            },
            {
                internalType: "contract IProxyRegistry",
                name: "_proxyRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DescriptorLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract INounsDescriptor",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "DescriptorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MinterLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
        ],
        name: "MinterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "NounBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                indexed: false,
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "NounCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "noundersDAO",
                type: "address",
            },
        ],
        name: "NoundersDAOUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "raffleEligible",
                type: "address[]",
            },
        ],
        name: "RaffleEligibleUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "winner",
                type: "address",
            },
        ],
        name: "RaffleWinner",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "SeederLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract INounsSeeder",
                name: "seeder",
                type: "address",
            },
        ],
        name: "SeederUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "COUNT_RAFFLE_FREE",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_RAFFLE_FREE",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "contractURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "descriptor",
        outputs: [
            {
                internalType: "contract INounsDescriptor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRaffleEligible",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDescriptorLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMinterLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isSeederLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "noundersDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxyRegistry",
        outputs: [
            {
                internalType: "contract IProxyRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "seeder",
        outputs: [
            {
                internalType: "contract INounsSeeder",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "seeds",
        outputs: [
            {
                internalType: "uint48",
                name: "background",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "body",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "accessory",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "head",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "glasses",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newContractURIHash",
                type: "string",
            },
        ],
        name: "setContractURIHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsDescriptor",
                name: "_descriptor",
                type: "address",
            },
        ],
        name: "setDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_noundersDAO",
                type: "address",
            },
        ],
        name: "setNoundersDAO",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "raffleEligible_",
                type: "address[]",
            },
        ],
        name: "setRaffleEligible",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsSeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        name: "setSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
